<div>
    <div id="modal-back" class="dialog-header">
            <div class="col-12 text-end">
                <button type="button" class="btn-close" (click)="onClose()" aria-label="Close"></button>
            </div>
            <div class="col-12 app-col">
                <span>{{title}}</span>
                <p *ngIf="pendingBtns || confirmedBtns"> <span *ngIf="pendingBtns" (click)="reserveButton('CONFIRMED')" class="sub-click">Conferma evento</span> <span *ngIf="confirmedBtns" (click)="reserveButton('COMPLETED')" class="sub-click">Completa evento</span> - <span  *ngIf="pendingBtns || confirmedBtns" (click)="reserveButton('CANCELLED')" class="sub-click">Annulla evento</span></p>
            </div>
    </div>
    <div class="row ">
        <div class="col-12">
            <div class="app-col">
                <i class="far fa-store modal-icon p-3" ></i>
                <p class="modal-data"> <span class="bold">Store di riferimento:</span> {{storeComsy}}</p>
            </div>
            <div class="app-col">
                <i class="far fa-map-marker-alt modal-icon p-3" ></i>
                <p class="modal-data"> <span class="bold">Indirizzo Store:</span> {{storeAddress}}</p>
            </div>
            <div class="app-col">
                <i class="far fa-sticky-note modal-icon p-3" ></i>
                <p class="modal-data"> <span class="bold">Argomento:</span> {{topic}}</p>
            </div>
            <div class="app-col">
                <i class="far fa-comment modal-icon p-3" ></i>
                <p class="modal-data"> <span class="bold">Messaggio:</span> {{notes}}</p>
            </div>
            <div class="app-col bord-b">
                <i class="far fa-clock modal-icon p-3" ></i>
                <p class="modal-data"> <span class="bold">Data:</span> {{date}}</p>                
            </div>
            <div class="app-col">
                <i class="far fa-user-alt modal-icon p-3" ></i>
                <p class="modal-data"> <span class="bold">Autore:</span> {{name}} {{surname}}</p>                
            </div>
            <div class="app-col">
                <i class="far fa-phone-alt modal-icon p-3" ></i>
                <p class="modal-data"> <span class="bold">Telefono:</span> {{telephone}}</p>                
            </div>
            <div class="app-col">
                <i class="far fa-envelope modal-icon p-3" ></i>
                <p class="modal-data"> <span class="bold">Email:</span> {{email}}</p>                
            </div>
            <div class="app-col">
                <i class="fas fa-clock modal-icon p-3" ></i>
                <p class="modal-data"> <span class="bold">Cliente Fastweb:</span> {{isFastwebCustomer}}</p>                
            </div>
            <div class="app-col">
                <i class="far fa-qrcode modal-icon p-3" ></i>
                <p class="modal-data"> <span class="bold">Codice cliente:</span> {{appointmentCode}}</p>                
            </div>
        </div>
    </div>    
</div>